import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";


export interface PastDueInvoicesPageStyles {
    page?: MobiusPageProps;

}

export const PastDueInvoicesPageStyles: PastDueInvoicesPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
    },
};

const styles = PastDueInvoicesPageStyles;
const PastDueInvoicesPage: React.FC<PageProps> = ({ id }) => {
    return (
        <Page {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
}

const pageModule: PageModule = {
    component: PastDueInvoicesPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "MyProfilePage" instead of this constant.
 */
export const PastDueInvoicesPageContext = "PastDueInvoicesPage";
